

exports.__esModule = true;

var _squid = require('squid');

var _util = require('../../fi-contingency-list/util');

var _index = require('xo-models/src/fi/index');

require('xo-ui-components/src/spinner-button/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoInitOtpDirective', {
    tag: 'xo-init-otp',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            required: true
        },
        phone: {
            type: 'var',
            required: false
        },
        cardModel: {
            type: 'var',
            required: true
        },
        onSuccess: {
            type: 'var',
            required: true
        },
        flag: {
            type: 'var',
            required: true
        },
        setErrorData: {
            type: 'var',
            required: true
        }
    },

    actions: {
        initOtp: function initOtp() {
            var _this = this;

            var handleContingencies = function handleContingencies() {
                var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var prop = arguments[1];

                var errorData = void 0;
                if (result.errorCodes) {
                    errorData = result;
                } else {
                    errorData = {
                        errorCodes: [result['0'] || 'ISSUER_DECLINE']
                    };
                }

                _this.setErrorData(errorData);

                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }
            };

            this.isProcessing = true;

            var resolveOTP = new _index.$ResolveOTP({ id: this.cardModel.id });

            resolveOTP.action('init', {
                data: {
                    phone: {
                        country_code: this.phone.IntDialingCountryCode,
                        number: this.phone.telephone
                    }
                },
                resultModel: {},
                success: function success() {
                    _this.onSuccess();
                },

                error: function error() {
                    handleContingencies();
                },

                contingencies: {
                    INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {

                        handleContingencies(result);
                        _util.$fiErrorUtil.addFieldErrors(result, _this.$element);
                    },
                    DEFAULT: function DEFAULT() {
                        handleContingencies();
                    }
                }
            })['finally'](function () {
                _this.isProcessing = false;
            });
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this2 = this;

            this.$watch('isProcessing', function (isProcessing) {
                if (isProcessing) {
                    _this2.$element.addClass('processing');
                } else {
                    _this2.$element.removeClass('processing');
                }
            });

            if (this.flag('fields.expiry') && !this.cardModel.get('expiry_month') || this.flag('fields.cvv') && !this.cardModel.get('security_code') || this.flag('fields.phone') && !(this.phone && this.phone.telephone)) {

                this.showInitScreen = true;
            } else {
                this.actions.initOtp();
            }

            $('#upopConfirmation .modalContainer').focus();
        }
    }
});


_squid.$Component;

_util.$fiErrorUtil;

_index.$ResolveOTP;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/confirm-upop/init/directive.js
// module id = ./components/xo-wallet-components/src/confirm-upop/init/directive.js
// module chunks = 1